const createRegisterForm = () =>
  new Vue({
    el: "#register-form-app",
    data: () => {
      return {
        formData: {
          email: "",
          password: "",
          agreeMarketing: true,
        },
        confirmPassword: "",
        showPassword: false,
        showConfirmPassword: false,
        passwordTimer: null,
        confirmPasswordTimer: null,
        errors: {},
        isSubmitting: false,
        touched: {
          email: false,
          password: false,
          confirmPassword: false,
        },
        emailDomains: [
          "gmail.com",
          "yahoo.com",
          "hotmail.com",
          "outlook.com",
          "icloud.com",
          "aol.com",
          "live.com",
          "protonmail.com",
          "zoho.com",
          "gmx.com",
          "mail.com",
        ],
        showEmailSuggestions: false,
        filteredDomains: [],
        emailInputFocused: false,
        successMessage: "",
        pageType: "",
        checkUrl: "web.AuthService/CheckEmail", // 检查邮箱是否注册
        signupUrl: "web.AuthService/Signup", // 注册
        loginUrl: "web.AuthService/Login", // 登录
        passwordRecoverUrl: "web.AuthService/PasswordRecover", // 找回密码
        customerActivateUrl: "web.AuthService/CustomerActivate", // 激活账号
        userUrl: "api/v1/profile",
      };
    },
    computed: {
      hasErrors() {
        return Object.keys(this.errors).length > 0;
      },
    },
    watch: {
      "formData.email": function (newValue) {
        if (newValue.length > 0) {
          const atIndex = newValue.indexOf("@");
          if (atIndex !== -1) {
            // 如果包含@符号，过滤匹配的域名
            const domainPart = newValue.slice(atIndex + 1).toLowerCase();
            this.filteredDomains = this.emailDomains
              .filter((domain) => domain.includes(domainPart))
              .map((domain) => "@" + domain);
          } else {
            // 如果不包含@符号，显示所有域名
            this.filteredDomains = this.emailDomains.map(
              (domain) => "@" + domain
            );
          }
          this.showEmailSuggestions =
            this.filteredDomains.length > 0 && this.emailInputFocused;
        } else {
          this.showEmailSuggestions = false;
        }
      },
    },
    methods: {
      /**
       * 选择邮箱域名
       * @param {string} domain - 选择的域名
       */
      selectEmailDomain(domain) {
        const atIndex = this.formData.email.indexOf("@");
        if (atIndex !== -1) {
          // 如果已经有@符号，替换后面的部分
          this.formData.email =
            this.formData.email.slice(0, atIndex + 1) + domain.slice(1);
        } else {
          // 如果没有@符号，添加@符号和域名
          this.formData.email = this.formData.email + domain;
        }
        this.showEmailSuggestions = false;
        // 验证邮箱
        this.validateField("email");
      },
      /**
       * 获取完整的邮箱建议
       * @param {string} domain - 域名
       * @returns {string} - 完整的邮箱建议
       */
      getEmailSuggestion(domain) {
        const atIndex = this.formData.email.indexOf("@");
        if (atIndex !== -1) {
          // 如果已经有@符号，保留@前面的部分，替换后面的部分
          return this.formData.email.slice(0, atIndex) + domain;
        } else {
          // 如果没有@符号，添加@符号和域名
          return this.formData.email + domain;
        }
      },

      /**
       * 处理邮箱输入框获得焦点
       */
      handleEmailFocus() {
        this.emailInputFocused = true;
        if (this.formData.email.length > 0) {
          // 检查是否已经包含@符号
          const atIndex = this.formData.email.indexOf("@");

          if (atIndex !== -1) {
            // 如果包含@符号，过滤匹配的域名
            const domainPart = this.formData.email
              .slice(atIndex + 1)
              .toLowerCase();
            this.filteredDomains = this.emailDomains
              .filter((domain) => domain.includes(domainPart))
              .map((domain) => "@" + domain);
          } else {
            this.filteredDomains = this.emailDomains.map(
              (domain) => "@" + domain
            );
          }
          console.log(this.filteredDomains);
          this.showEmailSuggestions = this.filteredDomains.length > 0;
        }
      },

      /**
       * 处理邮箱输入框失去焦点
       */
      handleEmailBlur() {
        // 延迟隐藏建议，以便用户可以点击建议
        setTimeout(() => {
          this.emailInputFocused = false;
          this.showEmailSuggestions = false;
          this.markAsTouched("email");
        }, 200);
      },

      /**
       * 处理点击外部区域
       */
      handleClickOutside(event) {
        const emailContainer = this.$refs.emailContainer;
        if (emailContainer && !emailContainer.contains(event.target)) {
          this.showEmailSuggestions = false;
        }
      },
      /**
       * 切换密码可见
       * @param {string} type - 'password' 或 'confirmPassword'
       */
      togglePasswordVisibility(type) {
        if (type === "password") {
          if (this.passwordTimer) {
            clearTimeout(this.passwordTimer);
            this.passwordTimer = null;
          }

          this.showPassword = !this.showPassword;

          if (this.showPassword) {
            this.passwordTimer = setTimeout(() => {
              this.showPassword = false;
              this.passwordTimer = null;
            }, 1000);
          }
        } else if (type === "confirmPassword") {
          if (this.confirmPasswordTimer) {
            clearTimeout(this.confirmPasswordTimer);
            this.confirmPasswordTimer = null;
          }

          this.showConfirmPassword = !this.showConfirmPassword;

          if (this.showConfirmPassword) {
            this.confirmPasswordTimer = setTimeout(() => {
              this.showConfirmPassword = false;
              this.confirmPasswordTimer = null;
            }, 1000);
          }
        }
      },
      /**
       * 标记字段是否被触摸
       * @param {string} field - 字段名
       */
      markAsTouched(field) {
        this.validateField(field);
        this.touched[field] = true;
      },

      /**
       * 验证单个字段
       * @param {string} field - 字段名称
       */
      validateField(field) {
        // 清除该字段的错误
        if (this.errors[field]) {
          const { [field]: _, ...rest } = this.errors;
          this.errors = rest;
        }

        // 根据字段类型验证
        switch (field) {
          case "email":
            if (!this.formData.email) {
              this.errors.email = "! Please enter email";
            } else if (
              !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)
            ) {
              this.errors.email = "! Please enter a valid email";
            }
            break;

          case "password":
            if (!this.formData.password) {
              this.errors.password = "! Please enter password";
            } else if (
              this.formData.password.length > 40 ||
              this.formData.password.length < 5
            ) {
              this.errors.password =
                "Password enter a password with 5 to 40 characters";
            }
            // 如果确认密码已填写，也验证确认密码
            if (this.touched.confirmPassword && this.confirmPassword) {
              this.validateField("confirmPassword");
            }
            break;

          case "confirmPassword":
            if (!this.confirmPassword) {
              this.errors.confirmPassword = "! Please enter confirm password";
            } else if (this.confirmPassword !== this.formData.password) {
              this.errors.confirmPassword = "Passwords do not match";
            }
            break;
        }
      },

      /**
       * 验证表单数据
       * @returns {boolean} 验证是否通过
       */
      validateForm() {
        // 清除所有错误
        this.errors = {};

        // 验证所有字段
        this.validateField("email");
        this.validateField("password");
        if (this.pageType == "register") {
          this.validateField("confirmPassword");
        }

        // 标记所有字段为已触摸
        Object.keys(this.touched).forEach((field) => {
          this.touched[field] = true;
        });

        return !this.hasErrors;
      },
      validateEmail() {
        if (!this.formData.email) {
          this.errors.email = "! Please enter email";
          return false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
          this.errors.email = "! Please enter a valid email";
          return false;
        }
        return true;
      },
      /**
       * 注册前校验账号是否可注册
       */
      async checkEmailAvailability() {
        if (!this.validateEmail()) return;
        const response = await fetchConnect(this.checkUrl, "POST", {
          email: this.formData.email,
        });
        if (!response.error) {
          if (response.data.exist) {
            this.pageType = "login";
          } else {
            this.pageType = "register";
          }
        }
      },
      getUser() {
        fetchRequest(this.userUrl, "Get").then((response) => {
          let userInfo = {};
          if (!response.error) {
            const loginFlag = true;
            userInfo = { loginFlag, ...response.data };
            document.cookie = `userInfo=${JSON.stringify(userInfo)}; path=/`;
          }
        });
      },

      /**
       * 登录
       */
      async loginCustomer(notTips) {
        if (!this.validateForm()) {
          return;
        }
        this.isSubmitting = true;
        try {
          const response = await fetchConnect(this.loginUrl, "POST", {
            username: this.formData.email,
            password: this.formData.password,
          });
          if (!response.error) {
            const data = response.data;
            const expire_at = new Date(data.expire_at * 1000);
            const payload = theme.decodeJWT(data.token);
            document.cookie = `token=${JSON.stringify(
              data.token
            )}; expires=${expire_at.toUTCString()}; path=/`;
            document.cookie = `s_token=${JSON.stringify(
              payload.token
            )}; expires=${expire_at.toUTCString()}; path=/`;
            notTips ? "" : (this.successMessage = "Login successfully!");
            // 3秒后清除成功消息
            setTimeout(() => {
              this.successMessage = "";
            }, 2000);
            window.location.href = "/pages/account";
            this.getUser();
          } else {
            this.errors.general = response.msg;
          }
        } catch (error) {
          console.error("Login error:", error);
          this.errors.general =
            error.message || "An error occurred during login";
        } finally {
          this.isSubmitting = false;
        }
      },

      /**
       * 注册新客户
       */
      async registerCustomer() {
        if (!this.validateForm()) {
          return;
        }
        this.isSubmitting = true;
        const params = {
          username: this.formData.email,
          password: this.formData.password,
          acceptsMarketing: this.formData.agreeMarketing,
        };
        try {
          const response = await fetchConnect(this.signupUrl, "POST", params);
          if (!response.error) {
            this.successMessage = "Registered successfully!";
            // 3秒后清除成功消息
            setTimeout(() => {
              this.successMessage = "";
            }, 2000);
            await this.loginCustomer(true);
            this.clearForm();
            window.location.href = "/pages/account";
          } else {
            this.errors.general = response.msg;
          }
        } finally {
          this.isSubmitting = false;
        }
      },

      /**
       * 发送重置密码的邮件
       */
      async sendResetPasswordEmail() {
        // 验证邮箱
        if (!this.validateEmail()) return;
        this.isSubmitting = true;

        const response = await fetchConnect(this.passwordRecoverUrl, "POST", {
          email: this.formData.email,
        });

        if (!response.error) {
          // 成功发送
          this.errors = {};
          this.successMessage =
            "Password reset email has been sent. Please check your inbox.";
          // 3秒后清除成功消息
          setTimeout(() => {
            this.successMessage = "";
            this.pageType = "login"; // 返回初始页面
          }, 2000);
        } else {
          this.errors.general = response.msg;
        }
        this.isSubmitting = false;
      },

      /**
       * 清除表单数据
       */
      clearForm() {
        this.formData = {
          email: "",
          password: "",
        };
        this.confirmPassword = "";
        this.errors = {};
        this.touched = {
          email: false,
          password: false,
          confirmPassword: false,
        };
      },
    },

    // 组件销毁时清除所有定时器
    beforeDestroy() {
      if (this.passwordTimer) {
        clearTimeout(this.passwordTimer);
      }
      if (this.confirmPasswordTimer) {
        clearTimeout(this.confirmPasswordTimer);
      }
      document.removeEventListener("click", this.handleClickOutside);
    },
    mounted() {
      // 添加点击外部区域的事件监听
      document.addEventListener("click", this.handleClickOutside);
    },
    template: `
      <div>
        <div class="register-form-container">
          <div v-if="errors.general" class="error-message general-error">
            {{ errors.general }}
          </div>

          <div v-if="pageType==''">
            <div class="form-group relative" ref="emailContainer">
              <input 
                type="email" 
                id="email" 
                autocomplete="off"
                v-model="formData.email"
                @focus="handleEmailFocus"
                @blur="handleEmailBlur"
                @keyup.enter="checkEmailAvailability"
                :class="{'error-input': errors.email}"
                placeholder="Enter your email"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
              >
              <div v-if="showEmailSuggestions" class="email-suggestions absolute">
                <div 
                  v-for="domain in filteredDomains" 
                  :key="domain" 
                  class="left"
                  @click="selectEmailDomain(domain)"
                >
                  {{ getEmailSuggestion(domain) }}
                </div>
              </div>
              <div v-if="errors.email" class="error-message absolute">{{ errors.email }}</div>
            </div>
            <div class="form-actions">
              <button type="button" class="register-button" @click.prevent="checkEmailAvailability">
                <span>Continue</span>
              </button>
            </div>
          </div>
          <div v-if="pageType=='register'">
            <div class="form-group relative" ref="emailContainer">
              <input 
                type="email" 
                id="email" 
                autocomplete="off"
                v-model="formData.email"
                @focus="handleEmailFocus"
                @blur="handleEmailBlur"
                @keyup.enter="registerCustomer"
                :class="{'error-input': errors.email}"
                placeholder="Enter your email"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
              >
              <div v-if="showEmailSuggestions" class="email-suggestions absolute">
                <div 
                  v-for="domain in filteredDomains" 
                  :key="domain" 
                  class="left"
                  @click="selectEmailDomain(domain)"
                >
                  {{ getEmailSuggestion(domain) }}
                </div>
              </div>
              <div v-if="errors.email" class="error-message absolute">{{ errors.email }}</div>
            </div>
            
            <div class="form-group relative">
              <input 
                :type="showPassword ? 'text' : 'password'" 
                id="password" 
                autocomplete="off"
                v-model="formData.password"
                @input="markAsTouched('password')"
                @keyup.enter="registerCustomer"
                :class="{'error-input': errors.password}"
                placeholder="Enter your password"
              >
              <div 
                class="toggle-password-btn" 
                @click="togglePasswordVisibility('password')"
              >
                <svg v-if="showPassword" class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <svg v-else class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              </div>
              <div v-if="errors.password" class="error-message absolute">{{ errors.password }}</div>
            </div>

            <div class="form-group relative">
              <input 
                :type="showConfirmPassword ? 'text' : 'password'" 
                id="confirm_password" 
                autocomplete="off"
                v-model="confirmPassword"
                @input="markAsTouched('confirmPassword')"
                @keyup.enter="registerCustomer"
                :class="{'error-input': errors.confirmPassword}"
                placeholder="Confirm password"
              >
              <div 
                class="toggle-password-btn" 
                @click="togglePasswordVisibility('confirmPassword')"
              >
                <svg v-if="showConfirmPassword" class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <svg v-else class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              </div>
              <div v-if="errors.confirmPassword" class="error-message absolute">{{ errors.confirmPassword }}</div>
            </div>

            <div class="form-group checkbox-group">
              <label class="checkbox-container">
                <input type="checkbox" v-model="formData.agreeMarketing">
                <span class="checkmark"></span>
                <span class="checkbox-text">I would like to receive offer and news</span>
              </label>
            </div>
            
            <div class="form-actions">
              <button 
                type="button" 
                class="register-button" 
                :disabled="isSubmitting"
                @click.prevent="registerCustomer"
              >
                <span v-if="isSubmitting">Registering...</span>
                <span v-else>Register</span>
              </button>
            </div>
          </div>
          <div v-if="pageType=='login'">
            <div class="form-group relative" ref="emailContainer">
              <input 
                type="email" 
                id="email" 
                autocomplete="off"
                v-model="formData.email"
                @focus="handleEmailFocus"
                @blur="handleEmailBlur"
                @keyup.enter="loginCustomer"
                :class="{'error-input': errors.email}"
                placeholder="Enter your email"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
              >
              <div v-if="showEmailSuggestions" class="email-suggestions absolute">
                <div 
                  v-for="domain in filteredDomains" 
                  :key="domain" 
                  class="left"
                  @click="selectEmailDomain(domain)"
                >
                  {{ getEmailSuggestion(domain) }}
                </div>
              </div>
              <div v-if="errors.email" class="error-message absolute">{{ errors.email }}</div>
            </div>
            
            <div class="form-group relative">
              <input 
                :type="showPassword ? 'text' : 'password'" 
                id="password" 
                autocomplete="off"
                v-model="formData.password"
                @input="markAsTouched('password')"
                @keyup.enter="loginCustomer"
                :class="{'error-input': errors.password}"
                placeholder="Enter your password"
              >
              <div 
                class="toggle-password-btn" 
                @click="togglePasswordVisibility('password')"
              >
                <svg v-if="showPassword" class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <svg v-else class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              </div>
              <div v-if="errors.password" class="error-message absolute">{{ errors.password }}</div>
            </div>

            <div class="flex justify-content-end mb5">
              <div class="cursor-pointer" @click="pageType='forgetPassword'">Forget Password?</div>
            </div>
            
            <div class="form-actions">
              <button 
                class="register-button" 
                :disabled="isSubmitting"
                @click.prevent="loginCustomer"
              >
                <span>Sign In</span>
              </button>
            </div>
          </div>

          <div class="form-actions" v-if="pageType=='forgetPassword'">
            <div class="form-group relative" ref="emailContainer">
              <input 
                type="email" 
                id="email" 
                autocomplete="off"
                v-model="formData.email"
                @focus="handleEmailFocus"
                @blur="handleEmailBlur"
                @keyup.enter="sendResetPasswordEmail"
                :class="{'error-input': errors.email}"
                placeholder="Enter your email"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
              >
              <div v-if="showEmailSuggestions" class="email-suggestions absolute">
                <div 
                  v-for="domain in filteredDomains" 
                  :key="domain" 
                  class="left"
                  @click="selectEmailDomain(domain)"
                >
                  {{ getEmailSuggestion(domain) }}
                </div>
              </div>
              <div v-if="errors.email" class="error-message absolute">{{ errors.email }}</div>
            </div>
            <div class="form-actions">
              <button 
                :disabled="isSubmitting"
                @click.prevent="sendResetPasswordEmail"
                class="register-button"
              >
                <span>Send Reset Email</span>
              </button>
            </div>
          </div>
        </div>
        <div class="login-tips">
          <div class="tips-title center">🌟 Welcome to GoodDIY! 🎉</div>
          <div class="tips-text ">
            Sign up today and get up to <span class="tips-highlight">$78</span> off your first order, plus free shipping
            on your first purchase!
          </div>
          <div class="tips-text">💎 Discover thousands of trending jewelry styles at unbeatable wholesale prices.</div>
          <div class="tips-text">
            🚚 Fast shipping, reliable service, and exclusive deals for our registered members.
          </div>
        </div>
        <div class="pwd_or_email-wrapper max-width-460" v-if="pageType!=''">
          <p class="email_title">or</p>
        </div>
        <div class="form-actions max-width-460" v-if="pageType!=''">
          <button
            v-if="pageType=='login'"
            class="register-button"
            @click="pageType='register'"
          >
            <span>Register</span>
          </button>
          <button
            v-if="pageType=='register' || pageType=='forgetPassword'"
            class="register-button"
            @click="pageType='login'"
          >
            <span>Sign In</span>
          </button>
        </div>
        <div v-if="successMessage" class="success-tips">
          <svg t="1722414541181" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3254" width="20" height="20">
            <path d="M512 896A384 384 0 1 0 512 127.936 384 384 0 0 0 512 896z m0 64A448 448 0 1 1 512 64a448 448 0 0 1 0 896z" fill="#67c23a" p-id="3255"></path>
            <path d="M298.944 548.48a32 32 0 0 1 45.248-45.312L457.344 616.32l248.96-248.96a32 32 0 0 1 45.184 45.312L480 684.16a32 32 0 0 1-45.248 0L298.88 548.48z" fill="#67c23a" p-id="3256"></path>
          </svg>
          {{ successMessage }}
        </div>
      </div>
    `,
  });
// 初始化Vue应用
// document.addEventListener("DOMContentLoaded", () => {
if (document.getElementById("register-form-app")) {
  window.registerForm = createRegisterForm();
}
// });
/**
 * <div class="login-link">
            Have an account? <a href="/account/login" class="underline-on-hover">Log in</a> to checkout faster.</a>
          </div>
 * 
 */
